import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Buffer } from 'buffer';
import { globalLoadingOff, globalLoadingOn } from '../../slices/globalLoading/globalLoadingSlice';
import { selectCurrentUserApiToken } from '../../slices/currentUser/currentUserSlice';
import ViewPdf from '../../components/ViewPdfLauncher';
import axiosInstance from '../../functions/axiosInstance';
import server_config from '../../ServerConfiguration';

const computable_publishing_node_server_address = server_config["computable_publishing_node_server_address"];

const hashCode = (str) => {
    let hash = 0;
    if (!str || str.length === 0) {
        return hash;
    }
    for (let i = 0; i < str.length; i++) {
        let chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

const handleDownload = (pdfData, fileName = "Sample") => {
    const linkSource = `data:application/pdf;base64,${pdfData}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName + ".pdf";
    downloadLink.click();
};

const getThePDF = async (dispatch, apiToken, fhirJson, pdfState, setPdfState, jsonHashState, setJsonHashState, download = false, pdfFileName = null, foi = undefined, m11 = false) => {
    if (!pdfState) {
        try {
            dispatch(globalLoadingOn());
            if (m11 && !fhirJson) {
                return await axiosInstance({
                    method: 'POST',
                    url: computable_publishing_node_server_address,
                    timeout: 120000,
                    data: { "functionid": "m11reporttopdf", "apiToken": apiToken, "foi": foi, "libraryfunction": "axios" },
                }).then(async (resp) => {
                    if (resp?.data?.success && resp.data.pdf?.data) {
                        let pdfData = Buffer.from(resp.data.pdf.data).toString("base64");
                        setPdfState(pdfData);
                        if (download && pdfData) {
                            handleDownload(pdfData, pdfFileName);
                        }
                        return pdfData;
                    }
                    //return resp.data;
                }).catch(async (error) => { console.log(error); });

            } else {
                let hash = hashCode(fhirJson.toString());
                if (hash !== jsonHashState) {  //So it doesn't do a repeat submission
                    setJsonHashState(hash);
                    ///console.log("CALLING SERVER with fhircompositionjsontopdf");
                    return await axiosInstance({
                        method: 'POST',
                        url: computable_publishing_node_server_address,
                        timeout: 120000,
                        data: { "functionid": "fhircompositionjsontopdf", "apiToken": apiToken, "fhirJson": fhirJson, "libraryfunction": "axios", m11: m11 },
                    }).then(async (resp) => {
                        if (resp?.data?.success && resp.data.pdf?.data) {
                            let pdfData = Buffer.from(resp.data.pdf.data).toString("base64");
                            setPdfState(pdfData);
                            if (download && pdfData) {
                                handleDownload(pdfData, pdfFileName);
                            }
                            return pdfData;
                        }
                        //return resp.data;
                    }).catch(async (error) => { console.log(error); });
                }
            }
        } catch (e) {
            console.log(e);
        } finally {
            dispatch(globalLoadingOff());
        }

    } else if (download) {
        handleDownload(pdfState, pdfFileName);
    }
    return pdfState;
}

const CompositionPdfViewer = ({ fhirJson }) => {
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const [pdfState, setPdfState] = useState();
    const [jsonHashState, setJsonHashState] = useState();

    let pdfFileName = fhirJson.id + " - " + (fhirJson.title ? fhirJson.title.substring(0, 60) : "Unnamed");

    const handleViewPdf = useCallback(() => {
        getThePDF(dispatch, apiToken, fhirJson, pdfState, setPdfState, jsonHashState, setJsonHashState, false, null);
    }, [apiToken, dispatch, fhirJson, pdfState, setPdfState, jsonHashState, setJsonHashState]);

    return <div className="unselectable">
        <ViewPdf label="View PDF" pdfData={pdfState} onLoad={handleViewPdf} />
        <button type="button" style={{ marginLeft: "12px" }}
            onClick={() => { getThePDF(dispatch, apiToken, fhirJson, pdfState, setPdfState, jsonHashState, setJsonHashState, true, pdfFileName); }}
        >{"Download PDF"}</button>
        <br />
    </div>;
};

export default CompositionPdfViewer;
export { getThePDF, hashCode, handleDownload };